import { useRef } from 'react';
import styled, { css } from 'styled-components';
import { colorShade } from '../utils/style';

interface Props {
    value: boolean;
    setValue: (value: boolean) => void;
    size?: ToggleSize;
}

export enum ToggleSize { SMALL, MEDIUM }

export default function Toggle({ value, setValue, size = ToggleSize.MEDIUM }: Props) {
    const state = useRef(value);
    const selfRef = useRef<HTMLDivElement>(null);

    if (typeof value === 'boolean' && state.current !== value) { state.current = !state.current; setState(); }

    function setState() {
        state.current ? selfRef.current?.classList.add('true') : selfRef.current?.classList.remove('true');
    }

    function onClick() {
        state.current = !state.current;
        setState();
        setValue(state.current);
    }

    return (
        <Wrapper ref={selfRef} size={size} className={state.current ? 'true' : ''}>
            <div onClick={onClick} className="switch-body">
                <div className="switch-handle"></div>
            </div>
        </Wrapper>
    );
};

const sizes = {
    [ToggleSize.SMALL]: css`
        min-width: 40px;
        min-height: 20px;

        .switch-body { width: 40px; height: 20px; border-radius: 16px; padding: 4px; }
        .switch-handle { width: 12px; height: 12px; }
        &.true .switch-handle { transform: translateX(20px); }
    `,
    [ToggleSize.MEDIUM]: css`
        min-width: 60px;
        min-height: 30px;

        .switch-body { width: 56px; height: 30px; border-radius: 16px; padding: 8px; }
        .switch-handle { width: 14px; height: 14px; }
        &.true .switch-handle { transform: translateX(26px); }
    `,
};

const Wrapper = styled.div<{ size: ToggleSize }>`
    display: flex;
    justify-content: center;
    align-items: center;


    .switch-body {
        background-color: ${props => colorShade(props.theme.backgroundColor, -0.3)};
        transition: background-color var(--ui-animation-duration);
        cursor: pointer;
    }

    .switch-handle {
        background-color: ${props => colorShade(props.theme.foregroundColor, 0.05)};
        border-radius: 6px;
        transition: background-color var(--ui-animation-duration), transform var(--ui-animation-duration);
        color: #ffffff22;
    }

    &.true {
        .switch-body { background-color: ${props => colorShade(props.theme.primaryColor, -0.4)}; }
        .switch-handle { background-color: ${props => props.theme.primaryColor}; }
    }

    ${({ size }) => sizes[size]}
`;